import React, { createContext, useEffect, useState } from 'react';
import { any } from 'prop-types';
import moment from 'moment';

export const AuditDateRangeContext = createContext({});

const AuditDateRange = ({ children }) => {
    const initialState = {
        init: `${moment().subtract(1, 'months').format('YYYY-MM-DD')} 00:00:00`,
        end: `${moment().add(1, 'days').format('YYYY-MM-DD')} 00:00:00`
    };

    const [date, setDate] = useState(initialState);

    useEffect(() => {
        setDate(initialState);
    }, [window.location.pathname]);

    const setNewDate = ({ init, end }) => setDate({
        init: `${moment(init).format('YYYY-MM-DD')} 00:00:00`,
        end: `${moment(end).format('YYYY-MM-DD')} 00:00:00`
    });

    const { init, end } = date;
    return (
        <AuditDateRangeContext.Provider value={{ setDate: setNewDate, init, end }}>
            { children }
        </AuditDateRangeContext.Provider>
    );
};

AuditDateRange.propTypes = {
    children: any
};

export default AuditDateRange;
